import { render, staticRenderFns } from "./ChannelLogs.view.vue?vue&type=template&id=0d990bc3&"
import script from "./ChannelLogs.view.vue?vue&type=script&lang=js&"
export * from "./ChannelLogs.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports